import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedSearch = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        ref={forwardedRef}
      >
        <g filter="url(#filter0_d_2890_285)">
          <g filter="url(#filter1_d_2890_285)">
            <path
              d="M15.8442 15.0708L17.0707 13.8444L19.4092 16.1828L18.1828 17.4093L15.8442 15.0708Z"
              fill="#ADC6DA"
            />
          </g>
          <g filter="url(#filter2_d_2890_285)">
            <path
              d="M17.8321 17.7696C17.4416 17.3791 17.4416 16.7459 17.8321 16.3554L18.3552 15.8323C18.7458 15.4418 19.3789 15.4418 19.7695 15.8323L23.324 19.3868C23.7146 19.7773 23.7146 20.4104 23.324 20.801L22.8009 21.3241C22.4104 21.7146 21.7772 21.7146 21.3867 21.3241L17.8321 17.7696Z"
              fill="url(#paint0_linear_2890_285)"
            />
          </g>
          <g filter="url(#filter3_d_2890_285)">
            <circle cx="11.5" cy="9.5" r="8.5" fill="url(#paint1_linear_2890_285)" />
          </g>
          <g filter="url(#filter4_i_2890_285)">
            <circle cx="11.5" cy="9.5" r="7.5" fill="url(#paint2_linear_2890_285)" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.87127 12.9383C6.6474 12.2444 6.52646 11.5044 6.52646 10.7361C6.52646 7.20947 9.07436 4.27798 12.4298 3.68198C12.0655 3.60937 11.6887 3.57129 11.3031 3.57129C8.13751 3.57129 5.57129 6.13751 5.57129 9.3031C5.57129 10.683 6.05892 11.9491 6.87127 12.9383Z"
            fill="url(#paint3_linear_2890_285)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2890_285"
            x="0"
            y="0"
            width="26.6169"
            height="26.6172"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.645426 0 0 0 0 0.804069 0 0 0 0 0.909831 0 0 0 0.41 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2890_285" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2890_285" result="shape" />
          </filter>
          <filter
            id="filter1_d_2890_285"
            x="15.3442"
            y="13.8442"
            width="4.56494"
            height="4.56494"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.5" />
            <feGaussianBlur stdDeviation="0.25" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.772549 0 0 0 0 0.835294 0 0 0 0 0.878431 0 0 0 1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2890_285" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2890_285" result="shape" />
          </filter>
          <filter
            id="filter2_d_2890_285"
            x="17.0393"
            y="15.5396"
            width="7.07764"
            height="7.07764"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.5" />
            <feGaussianBlur stdDeviation="0.25" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.468406 0 0 0 0 0.650265 0 0 0 0 0.775293 0 0 0 0.5 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2890_285" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2890_285" result="shape" />
          </filter>
          <filter
            id="filter3_d_2890_285"
            x="2.5"
            y="1"
            width="18"
            height="18"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.5" />
            <feGaussianBlur stdDeviation="0.25" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.173931 0 0 0 0 0.40068 0 0 0 0 0.564876 0 0 0 0.24 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2890_285" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2890_285" result="shape" />
          </filter>
          <filter
            id="filter4_i_2890_285"
            x="4"
            y="2"
            width="17"
            height="17"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="2" dy="3" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.146037 0 0 0 0 0.269829 0 0 0 0 0.384098 0 0 0 0.07 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2890_285" />
          </filter>
          <linearGradient
            id="paint0_linear_2890_285"
            x1="21.3398"
            y1="17.372"
            x2="19.3718"
            y2="19.34"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CEE5F5" />
            <stop offset="1" stopColor="#AECCE1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2890_285"
            x1="17.1667"
            y1="3.26667"
            x2="6.4"
            y2="16.8667"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BFD0DE" />
            <stop offset="1" stopColor="#92B8D3" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2890_285"
            x1="16.1154"
            y1="15.2692"
            x2="6.30769"
            y2="4.30769"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F4FAFF" />
            <stop offset="1" stopColor="#E7F2F9" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2890_285"
            x1="9.00052"
            y1="3.57129"
            x2="9.00052"
            y2="12.9383"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedSearch
